import { Button, Dialog } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import InboxReferenceLink from "../../config/ProfileDetailsData.json";
import CONFIG from "../../config";
import "./styles.css";

const NotFoundPopup = ({ open, onClose, entityId }) => {
  const handleEPH = () => {
    if (process.env.REACT_APP_STAGE === "prod") {
      window.open(
        `https://361.reltio.com/nui/N6QdWQ05wkTZjLA/profile?entityUri=entities%2F${entityId}`,
        "_blank",
      );
    } else {
      alert(1);
      window.open(
        `https://test.reltio.com/nui/mNNfGtHg2wVTZ1B/profile?entityUri=entities%2F${entityId}`,
        "_blank",
      );
    }

    // window.open(
    //   `${InboxReferenceLink.INBOX_REFERENCE_LINK[0][CONFIG.env] + entityId}`,
    //   "_blank",
    // );
  };
  return (
    <Dialog open={open} onClose={onClose} className="not-found-popup">
      <div className="popup-header">
        <IconButton
          aria-label="close"
          onClick={onClose}
          className="close-icon-container"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
        <span className="icon-wrapper">
          <ErrorOutlineIcon color="error" fontSize="large" />
        </span>
        <h4>Profile Not Found</h4>
      </div>
      <div className="popup-content">
        <p>
          We couldn't locate the profile you're looking for. The profile may not
          have been synced from the source system yet.
        </p>
        <div className="text-container">
          <p className="info-text">
            If this is a new profile, please allow some time for synchronization
            to complete, then try again.
          </p>
        </div>
        <p>Need to perform this operation elsewhere?</p>
        <Button
          className="go-to-eph-btn"
          onClick={handleEPH}
          endIcon={<OpenInNewIcon />}
        >
          Go to EPH
        </Button>
      </div>
    </Dialog>
  );
};

export default NotFoundPopup;
